import {combineReducers} from 'redux';
import userStats from './mpm/userStats';

export default combineReducers({userStats});



// WEBPACK FOOTER //
// ./src/reducers/app/other/mpm.js